import { Component } from '@angular/core';
import { PaginationComponent, PaginationItem } from '@spartacus/storefront';

@Component({
    selector: 'kb-nyab-delivery-nyab-pagination',
    templateUrl: './nyab-pagination.component.html',
    styleUrl: './nyab-pagination.component.scss'
})
export class NyabPaginationComponent extends PaginationComponent {
  isType(item: PaginationItem): boolean {
    return item.type != 'page';
  }
}
